import React from "react";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";

export default function Terms() {
  return (
    <div className="bg-cream min-h-screen">
      <Nav />
      <section className="max-w-3xl mx-auto px-6 sm:px-10 pt-20 pb-24">
        <div className="text-[11px] uppercase tracking-[0.35em] text-teal mb-6">— Terms of Service</div>
        <h1 className="font-display text-5xl sm:text-6xl text-navy leading-[0.95] mb-10">
          The <em className="text-gold not-italic">rules</em> of using LocalRida.
        </h1>
        <div className="space-y-6 text-navy/80 leading-relaxed text-[15px]">
          <p className="text-[10px] uppercase tracking-[0.28em] text-navy/50">Effective: February 2026</p>

          <h2 className="font-display text-3xl text-navy pt-6">1. What LocalRida is</h2>
          <p>
            LocalRida is a <strong>referral service</strong>. When you call or message our tracking line, we
            connect you with an independent, licensed private transfer operator active in the island you are
            travelling in. LocalRida itself does not own vehicles, employ drivers, or operate transportation.
          </p>

          <h2 className="font-display text-3xl text-navy pt-6">2. LocalRida is not the transportation provider</h2>
          <p>
            The actual transportation service is provided entirely by the independent licensed operator that
            takes your call. LocalRida is <strong>not liable</strong> for the conduct, safety, timeliness,
            vehicle condition, pricing, insurance coverage, or overall performance of any operator. Your
            transportation contract, once the operator accepts your booking, is between you and that operator.
          </p>

          <h2 className="font-display text-3xl text-navy pt-6">3. Acceptable use</h2>
          <p>
            By using LocalRida, you agree to provide accurate pickup information, treat the driver and vehicle
            with reasonable care, and not use the service to request unlawful transportation. We reserve the
            right to refuse routing of clearly abusive or fraudulent requests.
          </p>

          <h2 className="font-display text-3xl text-navy pt-6">4. Pricing and payment</h2>
          <p>
            LocalRida does not process payment for your ride. Fares, tolls, gratuities, and any surcharges are
            set and collected by the operator directly, in accordance with the operator's terms and local
            regulations.
          </p>

          <h2 className="font-display text-3xl text-navy pt-6">5. Recording &amp; data</h2>
          <p>
            Calls to our tracking line are recorded, as disclosed at the start of every call. Your data is
            handled in accordance with our{" "}
            <a className="underline hover:text-gold" href="/privacy">Privacy Policy</a>, which forms part of these terms.
          </p>

          <h2 className="font-display text-3xl text-navy pt-6">6. Disclaimer &amp; limitation of liability</h2>
          <p>
            LocalRida is provided "as is". To the maximum extent permitted by law, LocalRida disclaims all
            warranties, express or implied. LocalRida's aggregate liability arising from your use of the service
            is limited to the amount you paid to LocalRida directly — which, for the routing service itself, is
            zero.
          </p>

          <h2 className="font-display text-3xl text-navy pt-6">7. Changes</h2>
          <p>
            We may update these terms as our service evolves. Continued use after an update constitutes
            acceptance of the revised terms.
          </p>

          <h2 className="font-display text-3xl text-navy pt-6">8. Agreement</h2>
          <p>
            Using LocalRida — by calling, messaging, or otherwise engaging our service — constitutes agreement
            to these terms.
          </p>

          <h2 className="font-display text-3xl text-navy pt-6">Contact</h2>
          <p>
            Questions: <a className="underline hover:text-gold" href="mailto:legal@localrida.com">legal@localrida.com</a>.
          </p>
        </div>
      </section>
      <Footer />
    </div>
  );
}
